import React, { useEffect } from 'react'
import AOS from "aos";
import "aos/dist/aos.css";

export default function About() {
    useEffect(() => {
        AOS.init({ duration: 800, once: false });
    }, []);
    return (
        <div className='w-full h-auto text-customPurple px-20 py-28 max-lg:px-10'>
            <h1 data-aos='zoom-in-down' className='text-5xl font-bold text-lightPurple mb-20 w-60 m-auto max-sm:text-4xl max-sm:w-52 text-center'>About Me</h1>
            <div className='flex flex-row items-center gap-20 justify-between max-lg:flex-col max-lg:text-center'>
                <div className="w-3/5 max-xl:w-1/2 space-y-6 max-lg:w-full max-xl:text-sm">
                    <p data-aos='fade-up'>I’m a junior web developer who enjoys building websites that work well and feel simple to use. I started learning out of curiosity about how the web actually works, and it quickly became something I genuinely enjoy doing every day.</p>
                    <p data-aos='fade-up'>I work with HTML, CSS, JavaScript, React, Tailwind CSS, and .NET. I focus on writing clean, readable code and learning how to make sites run faster and smoother. I like understanding how things connect between the front end and the backend, and improving each part step by step.</p>
                    <p data-aos='fade-up'>I’m always learning new tools and ideas, experimenting with different ways to build better and more efficient projects. For me, development is about solving problems and making something useful that others can enjoy using.</p>
                </div>
                <div className="w-2/5 max-xl:w-1/2 h-full flex flex-row items-center justify-between gap-10 text-end max-lg:w-full max-lg:justify-center max-sm:gap-5">
                    <div className='flex flex-col gap-10 max-sm:gap-5'>
                        {skills[0]?.links.map((l, i) =>
                            <div data-aos='fade-up' ata-aos-anchor-placement="top-center" key={i}
                                className="p-[1px] rounded-xl bg-gradient-to-r from-darkPurple via-lightPurple to-mainPinkColor">
                                <div className='px-8 py-4 rounded-xl bg-white w-28 h-20 max-sm:w-24 max-sm:h-16 flex items-center justify-center hover:bg-transparent cursor-pointer hover:scale-110 transition-transform duration-300'>
                                    <img src={l.link} width={50} height={50} alt="Skill Icon" className='cover max-sm:w-8 max-sm:h-8' />
                                </div>
                            </div>
                        )}
                    </div>
                    <div className='flex flex-col gap-10 max-sm:gap-5'>
                        {skills[1]?.links.map((l, i) =>
                            <div data-aos='fade-up' key={i} className="p-[1px] rounded-xl bg-gradient-to-r from-darkPurple via-lightPurple to-mainPinkColor">
                                <div className='px-8 py-4 rounded-xl bg-white w-28 h-20 max-sm:w-24 max-sm:h-16 flex items-center justify-center hover:bg-transparent cursor-pointer hover:scale-110 transition-transform duration-300'>
                                    <img src={l.link} width={50} height={50} alt="Skill Icon" className='max-sm:w-8 max-sm:h-8' />
                                </div>
                            </div>
                        )}
                    </div>
                    <div className='flex flex-col gap-10 max-sm:gap-5'>
                        {skills[2]?.links.map((l, i) =>
                            <div data-aos='fade-up' key={i} className="p-[1px] rounded-xl bg-gradient-to-r from-darkPurple via-lightPurple to-mainPinkColor">
                                <div className='px-8 py-4 rounded-xl bg-white w-28 h-20 max-sm:w-24 max-sm:h-16 flex items-center justify-center hover:bg-transparent cursor-pointer hover:scale-110 transition-transform duration-300'>
                                    <img src={l.link} width={50} height={50} alt="Skill Icon" className='max-sm:w-8 max-sm:h-8' />
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
}

const skills = [
    {
        links: [
            { link: 'https://benscott.dev/imgs/html.6aa56206be02cf6404844871df1d2da6.png' },
            { link: 'https://benscott.dev/imgs/css.0ce0f0a2b4c4aa34b64c40e5278af3d1.png' },
            { link: 'https://benscott.dev/imgs/js.f8a28e905c78dadb79434b7ceebd52a0.png' },
        ]
    },
    {
        links: [
            { link: 'https://benscott.dev/imgs/react.cb15bfce2a9004ce61c5f79f805b067b.png' },
            { link: 'https://brandlogos.net/wp-content/uploads/2022/07/next.js-logo_brandlogos.net_zeccw.png' },
            { link: 'https://benscott.dev/imgs/sass.3706567f8b353c748df3850c1aabca46.png' },
            { link: 'https://benscott.dev/imgs/git.3092b5991e8accb9e7c36817c048a8d5.png' }
        ]
    },
    {
        links: [
            { link: 'https://upload.wikimedia.org/wikipedia/commons/thumb/c/cf/Angular_full_color_logo.svg/1200px-Angular_full_color_logo.svg.png' },
            { link: 'https://images.icon-icons.com/2415/PNG/512/csharp_plain_logo_icon_146577.png' },
            { link: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQnJvdRbTTnOGtjmdp8d4NuG6szCqe5xRSlTdTBAO_ZW55-9blejgQR_czaNNE4jneBmxE&usqp=CAU' }
        ]
    },
]